<template>
    <router-link class="card" :to="to">

        <template v-if="type === 'event'">
            <div class="picture">
                <router-link :to="to">
                    <template v-if="picturecard">
                        <img :src="picturecard"/>
                    </template>
                    <template v-else>
                        <img :src="picture"/>
                    </template>

                    <div v-if="live" class="live">
                        <img src="@/assets/images/icone-live.svg" alt="">
                        {{$t('home.sections.live')}}
                    </div>
                </router-link>
            </div>
            <div class="content">
                <img class="left" src="@/assets/images/element-bg-g.svg"/>
                <img class="right" src="@/assets/images/element-bg-d.svg"/>
                <h3 class="title">{{title}}</h3>
                <span class="country">{{country}}</span>
                <div class="date">
                    <div class="when"><img src="@/assets/images/calendrier-icone-black.svg" />{{getDate(date) | dateFormat(getDateFormat('string'), getDateFormat('translations'))}}</div>
                    <div class="time">{{time}}</div>
                </div>
                <div class="googlemap"><a :href="googlemap"><img src="@/assets/images/pointer-map-icone-black.svg" />{{where}}</a></div>
                <div class="summary">{{summary}}</div>
                <div class="share">
                    <span class="label">{{$t('events.share')}}</span>
                    <ul>
                        <li class="fb">
                            <a :href="`https://www.facebook.com/sharer/sharer.php?u=${hostname}${to}`"
                                @click.stop
                               target="_blank">
                                <span class="icon-facebook"></span>
                            </a>
                        </li>
                        <li class="twitter">
                            <a :href="`https://twitter.com/intent/tweet?text=${encodeURIComponent(title)}%20%7C%20Festival%20du%20monde%20Arabe%20de%20Montr%C3%A9al&url=${hostname}${to}`"
                                @click.stop
                               target="_blank">
                                <span class="icon-twitter"></span>
                            </a>
                        </li>
                        <li class="email">
                            <a :href="`mailto:?subject=${title} | Festival du monde Arabe de Montréal&body=${hostname}${to}`" @click.stop>
                                <svg width="21" height="19" viewBox="0 0 15 11">
                                    <g fill="none" fill-rule="evenodd">
                                        <g stroke="#131313">
                                            <g>
                                                <g>
                                                    <g>
                                                        <path d="M0 0H13.462V9.872H0z"
                                                              transform="translate(-279 -3204) translate(269 3045) translate(0 147) translate(10.77 12.564)"/>
                                                        <path d="M0 0.436L6.731 5.821 13.462 0.436"
                                                              transform="translate(-279 -3204) translate(269 3045) translate(0 147) translate(10.77 12.564)"/>
                                                    </g>
                                                </g>
                                            </g>
                                        </g>
                                    </g>
                                </svg>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </template>

        <template v-else>
            <div class="picture">
                <img :src="picture"/>
            </div>
            <div class="content">
                <img class="left" src="@/assets/images/element-bg-g.svg"/>
                <img class="right" src="@/assets/images/element-bg-d.svg"/>
                <h3 class="title">{{title}}</h3>
                <div class="summary">{{summary}}</div>
            </div>
        </template>

    </router-link>
</template>

<script>
    export default {
        name: "Card",
        props: {
            type: {
                type: String,
                default: '',
            },
            live: {
                type: Boolean,
                default: false,
            },
            title: {
                type: String,
                default: '',
            },
            date: {
                type: String,
                default: '',
            },
            time: {
                type: String,
                default: '',
            },
            country: {
                type: String,
                default: '',
            },
            picture: {
                type: String,
                default: '',
            },
            picturecard: {
                type: String,
                default: '',
            },
            googlemap: {
                type: String,
                default: '',
            },
            where: {
                type: String,
                default: '',
            },
            summary: {
                type: String,
                default: '',
            },
            to: {
                type: String,
                default: '',
            }
        },

        data() {
            return{
                hostname: `https://${window.location.hostname}`,
                dateFormatConfigFR: {
                    dayOfWeekNames: [
                        'Dimanche', 'Lundi', 'Mardi', 'Mecredi', 'Jeudi',
                        'Vendredi', 'Samedi'
                    ],
                    dayOfWeekNamesShort: [
                        'Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'
                    ],
                    monthNames: [
                        'janvier', 'février', 'mars', 'avril', 'mai', 'juin',
                        'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'
                    ],
                    monthNamesShort: [
                        'Jan', 'Fev', 'Mar', 'Avr', 'Mai', 'Jui',
                        'Jul', 'Aou', 'Sep', 'Oct', 'Nov', 'Dec'
                    ],
                    timezone: 0
                },
                dateFormatConfigEN: {
                    dayOfWeekNames: [
                        'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday',
                        'Friday', 'Saturday'
                    ],
                    dayOfWeekNamesShort: [
                        'Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'
                    ],
                    monthNames: [
                        'January', 'February', 'March', 'April', 'May', 'June',
                        'July', 'August', 'September', 'October', 'November', 'December'
                    ],
                    monthNamesShort: [
                        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
                    ],
                    timezone: 0
                },
                locale: document.documentElement.lang.toUpperCase(),
            }
        },

        methods:{
            getDate(eventDate){
                const tempDate = eventDate.substr(0, eventDate.indexOf(' '));
                const parsed = Date.parse(tempDate);

                return new Date(parsed);
            },
            getDateFormat(mode) {
                if (mode === 'string') {
                    if (this.locale === 'FR') {
                        return 'DD MMMM YYYY';
                    } else {
                        return 'MMMM DD, YYYY';
                    }
                }

                if (mode === 'translations') {
                    if (this.locale === 'FR') {
                        return this.dateFormatConfigFR;
                    } else {
                        return this.dateFormatConfigEN;
                    }
                }
            }
        }


    }
</script>

<style scoped>

</style>
